export const CONNECTIVITY_CONFIG = {
    "CONNECTIVITY_URL_BASEPATH": "https://cdn.dev.direct.firstam.com/default/assets/landing-page/images/", // image location
    "DEFAULT_SPEED_LIMIT": 10 , //Mbps
    "CONNECTIVITY_TEST_DELAY": 1000, // millisecs. Wait time to make the next hit
    "BANNNER_TIMEOUT": 10000,  // millisecs. Time to show the banner
    "CONNECTIVITY_TEST_COUNT": 8 // how many times to download the image
}